import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function DeadlineBanner() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // April 3rd, 2026 at 11:59 PM Eastern Time
    const deadline = new Date('2026-04-03T23:59:59-04:00').getTime();
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = deadline - now;
      if (distance < 0) {
        clearInterval(timer);
        return;
      }
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <>
      <div className="fixed top-0 left-0 right-0 z-50 bg-red-950 border-b-2 border-red-600 py-2 px-3 md:px-4" data-id="element-608">
        <div className="max-w-7xl mx-auto flex items-center gap-3 md:gap-4" data-id="element-609">
          {/* Left spacer - matches button width to keep center content truly centered (desktop only) */}
          <div className="hidden md:block w-[120px] flex-shrink-0" data-id="element-610" />

          {/* Center: Timer message and countdown */}
          <div className="flex items-center gap-2 md:gap-3 flex-1 min-w-0 justify-center" data-id="element-611">
            <Clock className="w-4 h-4 md:w-5 md:h-5 text-red-500 animate-pulse flex-shrink-0" data-id="element-612" />
            <div className="flex flex-col md:flex-row md:items-center md:gap-3 min-w-0" data-id="element-613">
              {/* Mobile: Short message */}
              <p className="text-red-100 font-bold text-xs md:hidden leading-tight" data-id="element-614">
                OFFER ENDS IN
              </p>
              {/* Desktop: Full message */}
              <p className="hidden md:block text-red-100 font-bold text-base leading-tight whitespace-nowrap" data-id="element-615">
                🔥 Enrollment Period Ends In
              </p>
              <div className="flex items-center gap-1.5 text-red-100 text-xs md:text-sm" data-id="element-616">
                <span className="font-mono font-bold" data-id="element-617">
                  {String(timeLeft.days).padStart(2, '0')}d
                </span>
                <span data-id="element-618">:</span>
                <span className="font-mono font-bold" data-id="element-619">
                  {String(timeLeft.hours).padStart(2, '0')}h
                </span>
                <span data-id="element-620">:</span>
                <span className="font-mono font-bold" data-id="element-621">
                  {String(timeLeft.minutes).padStart(2, '0')}m
                </span>
                <span data-id="element-622">:</span>
                <span className="font-mono font-bold" data-id="element-623">
                  {String(timeLeft.seconds).padStart(2, '0')}s
                </span>
              </div>
            </div>
          </div>

          {/* Right side: CTA Button */}
          <button onClick={() => {
          const pricingSection = document.querySelector('[data-pricing-section]');
          if (pricingSection) {
            pricingSection.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }} className="flex-shrink-0 px-3 md:px-5 py-1.5 md:py-2 bg-amber-500 hover:bg-amber-400 text-black font-bold text-[11px] md:text-sm rounded-lg transition-all duration-300 shadow-lg hover:shadow-amber-500/50 hover:scale-105 whitespace-nowrap cursor-pointer md:w-[120px] text-center" data-id="element-624">
            Join Now
          </button>
        </div>
      </div>
      {/* Spacer to prevent content from hiding behind the fixed banner */}
      <div className="h-[52px] md:h-[48px]" data-id="element-625" />
    </>;
}